<template>
  <div>
    <gm-xs-hxp-census />
  </div>
</template>

<script>
// 获取接口地址
import GmXsHxpCensus from '../components/tjbb/gmxshxpCensus.vue'

export default {
  name: 'GmxshxpCensus',
  components: {
    // sideMenu,
    // Header,
    GmXsHxpCensus
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
